<ion-list>
  <ion-list-header class="ion-padding-horizontal flex flex-column align-items-start">
    <h1>{{ title }}</h1>
    <p *ngIf="!!subtitle">{{ subtitle }}</p>
  </ion-list-header>
  <ng-container *ngFor="let item of listOptions">
    <ion-item [attr.data-cy]="'menu-item-' + item.label" detail="false" button="true" class="kudo-range" style="overflow: visible">
      <fa-icon *ngIf="item.icon" [icon]="item.icon" style="margin-right: 5px"></fa-icon>
      <ion-label slot="start">{{ item.label }}</ion-label>
      <ion-col>
        <ion-range class="custom-slider" min="0" max="10" step="1" snaps="true" ticks="false" [pin]="true" [value]="item.value"
          (ionChange)="item.value = $event.detail.value" style="padding: 0;">
          <div slot="start" style="width:3px;height:12px;margin:0;"
            [ngStyle]="{'background-color': item.value?'var(--bar-background-active)':'var(--ion-color-step-200)'}">
          </div>
          <div slot="end" style="width:3px;height:12px;margin:0;"
            [ngStyle]="{'background-color': item.value===10?'var(--bar-background-active)':'var(--ion-color-step-200)'}">
          </div>
        </ion-range>
      </ion-col>
    </ion-item>
  </ng-container>

  <ion-item *ngIf="listOptions.length === 0">No Actions Available.</ion-item>

  <ion-grid>
    <ion-row>
      <ion-col>
        <ion-button expand="block" color="medium" mode="ios" (click)="popoverGC.dismiss(null, 'cancel')">
          Cancel
        </ion-button>
      </ion-col>
      <ion-col>
        <ion-button expand="block" mode="ios" (click)="submit()">
          {{ doneText }}
        </ion-button>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-list>